/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export const HISTOGRAM_MAX = 20
export const DROPDOWN_MAX = 15
